import { createTheme } from "@mui/material/styles";
const theme = createTheme({
  palette: {
    primary: { main: "#10AC84" },
    secondary: { main: "#295169" },
  },
});

export default theme;
